window.axios = require('axios');
import Alpine from "alpinejs";
import Fuse from "fuse.js";

window.Fuse = Fuse;
window.Alpine = Alpine;

Alpine.start();

import hljs from 'highlight.js/lib/core';

// Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('xml', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('text', require('highlight.js/lib/languages/plaintext'));
// hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));

document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightElement(block);
});

